import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "compare",
  label: "Product Comparison",
  description: "A lookbook line sheet comparing up to 4 pieces side by side: 3:4 photo, brand and name, sale price with % off (cheapest marked), colour swatches, size chips, fit, fabric and other attributes, category and brand, a show-differences-only switch, Add to bag and remove.",
  supportedPages: ["compare"],
  variants: [
    {
      id: "v1",
      label: "Table",
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
